import Service from "@/utils/api/service";
import Pagination from "@/components/share/pagination";
import Helper from "@/utils/global/func";
import TableLoading from "@/components/share/table-loading";
import NoItem from "@/components/share/table-no-item";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import Multiselect from "vue-multiselect";
import { mapState } from "vuex";

export default {
  name: "ListDeliveryFeeDistrict",
  data() {
    return {
      isFetching: true,
      isDeleting: false,
      isNoData: false,
      fields: {
        id: "",
        index: "",
      },
      search: {
        // dateRange: [],
        branchId: "",
      },
      display: {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      },
      data: {
        limit: 10,
        detail: {},
        items: [],
        pagination: {
          limit: 10,
          page: 1,
          total: 0,
          totalPage: 0,
        },
      },
    };
  },
  components: {
    Pagination,
    TableLoading,
    NoItem,
    DatePicker,
    Multiselect,
  },
  created() {
    this.setParams();
    this.getList();
  },
  watch: {
    "$route.fullPath": function () {
      this.setParams();
      this.getList();
    },
  },
  computed: {
    ...mapState(["permissions"]),
  },
  mounted() {},
  methods: {
    setParams() {
      this.search = this.$helper.setParams(
        this.search,
        this.$root.$route.query
      );
    },

    checkoutPermission(permissionName) {
      if (this.permissions) {
        let result = false;
        this.permissions.find((item) => {
          item.permissions.find((permission) => {
            if (permission.name == permissionName) {
              result = true;
            }
          });
        });

        return result;
      }
    },

    getFullImage(path) {
      return process.env.VUE_APP_BASE_URL_IMAGE + path;
    },

    htmlToText(html) {
      return Helper.convertToPlain(html);
    },

    linkPage(type, index) {
      if (index >= 0) {
        this.$router.push({
          name: type,
          query: { id: this.data.items[index].id },
        });
      } else
        this.$router.push({
          name: type,
        });
    },

    getList() {
      this.isFetching = true;
      this.isNoData = false;
      let query = this.$root.$route.query;
      let setQuery = this.$helper.filterKeyMapping({
        page: query?.page || 1,
        branchId: this.search?.branchId?.id ?? "",
        ...query,
      });

      setQuery?.startDate &&
        (setQuery.minDate = new Date(setQuery?.startDate).toISOString()) &&
        delete setQuery.startDate;
      setQuery?.endDate &&
        (setQuery.maxDate = new Date(setQuery?.endDate).toISOString()) &&
        delete setQuery.endDate;

      let params = this.$helper.queryParam(setQuery);

      Service.getDeliveryFeeDistricts(params).then((response) => {
        this.isFetching = false;
        if (response?.statusCode) {
          if (response?.statusCode === "4410") {
            Service.refreshToken().then((response) => {
              if (response === "ok") {
                this.getList();
              }
            });
          } else if (response?.statusCode === "403") {
            this.isNoData = true;
            this.data.items = [];
            this.$toasted.show(response?.message);
            return;
          } else {
            this.$toasted.show(response?.message);
            return;
          }
        } else {
          if (response?.data.length > 0) {
            this.isNoData = false;
            this.data.items = response?.data;
            this.data.pagination = Helper.calculatePagination(response?.meta);
            return;
          } else {
            this.data.items = [];
            this.isNoData = true;
            return;
          }
        }
      });
    },

    async searchItems() {
      // let query = this.$helper.filterKeyMapping({
      //   limit: 10,
      //   page: 1,
      //   branchId: this.search?.branchId?.id ?? "",
      //   ...this.search,
      // });
      // await this.$router.push({ query }).catch(() => {});
      this.getList();
    },

    popupModalDelete(index) {
      this.display.modal.delete.index = index;
      this.display.modal.delete.show = true;
    },

    deleteItem() {
      this.isDeleting = true;
      let popupBannerId = this.data.items[this.display.modal.delete.index].id;
      Service.deleteDeliveryFeeDistrict(popupBannerId).then((response) => {
        if (response.statusCode) {
          if (response.statusCode == "4410") {
            Service.refreshToken().then((response) => {
              if (response == "ok") {
                this.deleteItem();
              }
            });
          } else {
            this.isDeleting = false;
            this.$toasted.show(response.message);
          }
        } else {
          this.isDeleting = false;
          this.data.items.splice(this.display.modal.delete.index, 1);
          this.data.pagination.total -= 1;
          this.$toasted.show("Delivery Branch has been deleted.");
          this.closeModal();
        }
      });
    },

    imagePreview(index) {
      if (this.data.items[index].imageUrl) {
        this.display.modal.imagePreview.index = index;
        this.display.modal.imagePreview.show = true;
      }
    },

    closeModal() {
      this.display = {
        modal: {
          delete: {
            index: -1,
            show: false,
          },
          imagePreview: {
            show: false,
            index: "",
          },
        },
      };
    },
  },
};
